export const environment = {
  production: true,

  // caritas prod server
  // authApiUrl: "http://172.16.5.224:6400",
  // apiUrl: "http://172.16.5.224:6008",
  //  applicantsUrl: "http://172.16.5.224:6400",
  //  supplierUrl: "http://172.16.5.224:6008",

  // caritas test server
   authApiUrl:'https://selfservice.caritas-mfb.co.ke:6565', 
   apiUrl:  'https://selfservice.caritas-mfb.co.ke:6004',
   applicantsUrl:  'https://selfservice.caritas-mfb.co.ke/applicant/',
   supplierUrl:  'https://selfservice.caritas-mfb.co.ke/supplier/',
  // authApiUrl: "http://172.16.5.27:6565",
  // apiUrl: "http://172.16.5.27:6004",
  //  applicantsUrl: "http://172.16.5.27:6565",
  //  supplierUrl: "http://172.16.5.27:6004",

  // server 52
  //  authApiUrl: 'http://197.155.71.138:6802',
  //  apiUrl: 'http://197.155.71.138:6801',
  //  applicantsUrl:'http://197.155.71.138:6802',
  //  supplierUrl: 'http://197.155.71.138:6801',

  // authApiUrl: 'http://localhost:6400',
  // apiUrl: 'http://localhost:6300'
  //  applicantsUrl:'http://localhost:6400',
  //  supplierUrl:'http://localhost:6300'
};


